import React from 'react';
import '../styles/HeaderOption.css';
import {Avatar} from "@material-ui/core";
import { useSelector } from 'react-redux';
import { fetchUser } from '../features/UserSlice';

function HeaderOption({AvatarPic, Icon, title, onClick,shouldShowAvatar}) {
    const loggedInUser = useSelector(fetchUser);
    return (
        <div className="headerOption" onClick={onClick}>
            {Icon && <Icon className="headerOption_icon"/>}
            {shouldShowAvatar && <Avatar className="headerOption_icon">
                {loggedInUser?.displayName[0]}</Avatar>}
            <h3 className="headerOption_title">{title}</h3>
            
        </div>
    );
}

export default HeaderOption;